import React, { useEffect } from "react";
import QuestTwo from "../../components/quote-components/quoteQuestions/QuestTwo";
import { useNavContext } from "../../context-api/nav-context";

const QuestionTwo = () => {
  const { closeNavbarMenu } = useNavContext();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <main onMouseOver={closeNavbarMenu}>
      <QuestTwo />
    </main>
  );
};

export default QuestionTwo;
